import { ReactComponent as LinkedinRound } from './icon.svg'

export default LinkedinRound
